interface Props {
    type: string;
    name: string;
    placeholder?: string;
    label?: string;
    value?: string;
    className?: string;
    className2?: string;
    error?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormInput = ({ type, name, placeholder, label, className, className2, error, ...props }: Props) => {
    return (
        <div className={className}>
            <label className={`block mb-1 md:text-[16px] text-[14px] font-medium text-primery-blue-900 ${className2}`}>
                {label}
            </label>
            <input
                type={type}
                name={name}
                className={`w-full p-3 rounded-lg border dark:bg-[#0D0D0D] md:text-[14px] text-[12px] text-gray-600 dark:text-[#3B3B3B] ${
                    error
                        ? 'border-red-500 focus:border-red-500 focus:ring-red-200'
                        : 'border-[#E8E7EA] hover:border-[#d9d8db] focus:border-primery-blue-900 focus:ring-primery-blue-200'
                } focus:outline-none focus:ring-2 transition-colors`}
                placeholder={placeholder}
                {...props}
            />
            {error && <p className="mt-1 text-sm text-red-600 text-right">{error}</p>}
        </div>
    );
};

export default FormInput;
